<section class="modal">
  <div class="modal-header">
    <h3>
      {{ data?.content?.title || data?.title | uppercase}}
    </h3>
  </div>
  <div class="modal-content">
    <p>
      {{ data?.content.message }}
    </p>
    <br>
    <span>{{ data?.content?.err }}</span>
  </div>
  <div class="modal-footer">
    <ng-container *ngIf="data">
      <analysis-buttons [id]="'btnFinish'" [label]="data?.content?.button || 'Ok, vou entender o erro'" [kind]="'primary'" [size]="'large'" (clicked)="closeDialog('completed')"></analysis-buttons>
    </ng-container>
  </div>
</section>